import React, { Component, Fragment } from 'react';
import { services } from '@comall-backend-builder/core';
import { Button as AntButton, Table, Select, InputNumber, message, Spin } from 'antd';
import { errorHandle } from '../../services/error-handle';

interface ChangePriceSelectorProps {
    componentId: string;
}

interface ChangePriceSelectorStates {
    columns: object[];
    options: object[];
    tableData: object[];
    orderId: string;
    loading: boolean;
    spinning: boolean;
}

export class ChangePriceSelector extends Component<
    ChangePriceSelectorProps,
    ChangePriceSelectorStates
> {
    constructor(props: ChangePriceSelectorProps) {
        super(props);
        this.state = {
            spinning: true,
            orderId: '',
            columns: [
                {
                    title: 'SKN',
                    dataIndex: 'sknCode',
                    key: 'sknCode',
                },
                {
                    title: 'SKU',
                    dataIndex: 'skuCode',
                    key: 'skuCode',
                },
                {
                    title: '商品名称',
                    dataIndex: 'skuName',
                    key: 'skuName',
                },
                {
                    title: '售价',
                    dataIndex: 'price',
                    key: 'price',
                },
                {
                    title: '改价',
                    key: 'changePrice',
                    dataIndex: 'changePrice',
                    render: (_: any, record: any) => (
                        <InputNumber
                            disabled={
                                record.itemType === 'GIFT_NEW' || record.itemType === 'PACK_NEW'
                            }
                            key={record.sknCode}
                            min={0}
                            max={record.price}
                            onChange={(val) => this.onChangePrice(val, record)}
                        />
                    ),
                },
            ],
            options: [],
            tableData: [],
            loading: false,
        };
        this.loadSknList = this.loadSknList.bind(this);
        this.onChangePrice = this.onChangePrice.bind(this);
        this.saveSknChangePrice = this.saveSknChangePrice.bind(this);
    }
    componentWillMount() {
        services.api
            .get({}, { apiPath: '/changePrice/orderList' })
            .then((res: any) => {
                const result = res || [];
                this.setState({
                    options: result,
                    spinning: false,
                });
            })
            .catch((e: any) => {
                errorHandle(e);
            });
    }
    loadSknList(id: any) {
        this.setState({
            loading: true,
        });
        services.api
            .get({}, { apiPath: `/changePrice/orderSkn/${id}` })
            .then((res: any) => {
                const result = res || [];
                this.setState({
                    tableData: result,
                    orderId: id,
                    loading: false,
                });
            })
            .catch((e: any) => {
                errorHandle(e);
            });
    }
    onChangePrice(val: any, record: any) {
        // console.log(val, record)
        record.changePrice = val;
    }
    saveSknChangePrice() {
        const { orderId, tableData } = this.state;
        if (!orderId) {
            message.warning('请选择订单');
            return false;
        }
        const changeList = tableData.filter((item: any) => item.changePrice);
        if (!changeList.length) {
            message.warning('请修改商品价格');
            return false;
        }
        this.setState({
            spinning: true,
        });
        const items = changeList.map((item: any) => ({
            sknCode: item.sknCode,
            changePrice: item.changePrice,
        }));
        const params = {
            orderId: orderId,
            item: items,
        };
        services.api
            .post(params, { apiPath: '/changePrice/add' })
            .then((res: any) => {
                message.success('订单改价申请成功！');
                services.navigation.goBack();
            })
            .catch((e: any) => {
                errorHandle(e);
            })
            .finally(() => {
                this.setState({
                    spinning: false,
                });
            });
    }

    render() {
        return (
            <Fragment>
                <Spin spinning={this.state.spinning}>
                    <span>选择销售订单：</span>
                    <Select
                        showSearch
                        style={{ width: 300, marginBottom: '10px' }}
                        placeholder="请选择销售订单"
                        optionFilterProp="children"
                        onChange={(val) => this.loadSknList(val)}
                    >
                        {this.state.options.map((item: any) => (
                            <Select.Option key={item.id} value={item.id}>
                                {item.orderNo}
                            </Select.Option>
                        ))}
                    </Select>
                    <Table
                        rowKey="sknCode"
                        loading={this.state.loading}
                        pagination={false}
                        columns={this.state.columns}
                        dataSource={this.state.tableData}
                    />
                    <div style={{ textAlign: 'right', marginTop: '10px' }}>
                        <AntButton
                            onClick={() => services.navigation.goBack()}
                            style={{ marginRight: '10px' }}
                        >
                            取消
                        </AntButton>
                        <AntButton type="primary" onClick={this.saveSknChangePrice}>
                            保存
                        </AntButton>
                    </div>
                </Spin>
            </Fragment>
        );
    }
}
